"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.array.includes.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.includes.js");

require("core-js/modules/es.string.replace.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAction = exports.getId = exports.getTitle = exports.getActive = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

require("regenerator-runtime/runtime.js");

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _isLogin = require("../constants/isLogin");

var _client = require("@apollo/client");

var _notification = _interopRequireDefault(require("antd/lib/notification"));

var _jsCookie = _interopRequireDefault(require("js-cookie"));

var _menu = require("../constants/menu");

var _this = void 0;

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n                  fragment viewerFragment on User {\n                    id\n                    locale\n                  }\n                "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n              mutation updateShopperLanguagePreference(\n                $input: UpdateShopperLanguagePreferenceInput!\n              ) {\n                updateShopperLanguagePreference(input: $input) {\n                  status\n                }\n              }\n            "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n            mutation logout {\n              logout @client {\n                status\n              }\n            }\n          "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var getActive = function getActive(url, _ref) {
  var router = _ref.router,
      locale = _ref.locale,
      currency = _ref.currency,
      id = _ref.id,
      action = _ref.action;

  switch (action) {
    case _menu.MENU_ACTION_TYPES.AUTH:
      return /\/login/.test(router.pathname);

    default:
      {
        if (id === locale || id === currency) return true;
        return [router.asPath.replace(/\//g, '%2F'), encodeURIComponent(router.asPath), "http://".concat(router.domain).concat(router.asPath).replace(/\//g, '%2F'), encodeURIComponent("http://".concat(router.domain).concat(router.asPath)), "https://".concat(router.domain).concat(router.asPath).replace(/\//g, '%2F'), encodeURIComponent("https://".concat(router.domain).concat(router.asPath))].includes(encodeURIComponent(url));
      }
  }
};

exports.getActive = getActive;

var getTitle = function getTitle(_ref2) {
  var _user$memberGroup;

  var isLogin = _ref2.isLogin,
      user = _ref2.user,
      t = _ref2.t,
      getLanguage = _ref2.getLanguage,
      id = _ref2.id,
      action = _ref2.action,
      title = _ref2.title,
      params = _ref2.params;

  switch (action) {
    case _menu.MENU_ACTION_TYPES.LOCALE:
      return t("menu:".concat(id));

    case _menu.MENU_ACTION_TYPES.CURRENCY:
      switch (id) {
        case 'CNY':
        case 'JPY':
          return "\xA5 ".concat(id);

        case 'EUR':
          return '€ EUR';

        case 'VND':
          return '₫ VND';

        case 'KRW':
          return '₩ KRW';

        case 'MYR':
          return 'RM MYR';

        case 'TWD':
        case 'USD':
        case 'HKD':
        case 'SGD':
        default:
          return "$ ".concat(id);
      }

    case _menu.MENU_ACTION_TYPES.AUTH:
      if (isLogin !== _isLogin.NOTLOGIN) return params !== null && params !== void 0 && params.displayMemberGroup && user !== null && user !== void 0 && (_user$memberGroup = user.memberGroup) !== null && _user$memberGroup !== void 0 && _user$memberGroup.name ? user.memberGroup.name : null;
      return getLanguage(title);

    default:
      switch (id) {
        case 'ORDERS':
        case 'SETTINGS':
        case 'RECIPIENTS':
        case 'PASSWORD_CHANGE':
        case 'WISHLIST':
        case 'REWARD_POINTS':
        case 'LOGOUT':
          return t("menu:".concat(id));

        default:
          return getLanguage(title);
      }

  }
};

exports.getTitle = getTitle;

var getId = function getId(_ref3) {
  var locale = _ref3.locale,
      currency = _ref3.currency,
      id = _ref3.id,
      action = _ref3.action;
  var isUuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(id);
  if (!isUuid) return id;

  switch (action) {
    case _menu.MENU_ACTION_TYPES.LOCALE:
      return locale;

    case _menu.MENU_ACTION_TYPES.CURRENCY:
      return currency;

    default:
      return id;
  }
};

exports.getId = getId;

var getAction = function getAction(_ref4) {
  var isLogin = _ref4.isLogin,
      t = _ref4.t,
      i18n = _ref4.i18n,
      id = _ref4.id,
      action = _ref4.action,
      setCurrency = _ref4.setCurrency,
      client = _ref4.client;

  switch (action) {
    case _menu.MENU_ACTION_TYPES.AUTH_LOGOUT:
      {
        return /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
          var _yield$client$mutate, data;

          return _regenerator["default"].wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return client.mutate({
                    mutation: (0, _client.gql)(_templateObject())
                  });

                case 2:
                  _yield$client$mutate = _context.sent;
                  data = _yield$client$mutate.data;
                  if ((data === null || data === void 0 ? void 0 : data.logout.status) === 'OK') _notification["default"].success({
                    message: t('ducks:signout-success')
                  });else _notification["default"].error({
                    message: t('ducks:signout-failure-message')
                  });

                case 5:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));
      }

    case _menu.MENU_ACTION_TYPES.LOCALE:
      {
        return /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
          return _regenerator["default"].wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (!(isLogin !== _isLogin.NOTLOGIN)) {
                    _context2.next = 3;
                    break;
                  }

                  _context2.next = 3;
                  return client.mutate({
                    mutation: (0, _client.gql)(_templateObject2()),
                    variables: {
                      input: {
                        locale: id
                      }
                    },
                    update: function update(cache, _ref7) {
                      var updateShopperLanguagePreference = _ref7.data.updateShopperLanguagePreference;
                      var user = _this.props.user;
                      if (user !== null && user !== void 0 && user.id || updateShopperLanguagePreference.status !== 'OK') return;
                      cache.writeFragment({
                        id: user.id,
                        fragment: (0, _client.gql)(_templateObject3()),
                        data: {
                          __typename: 'User',
                          id: user.id,
                          locale: id
                        }
                      });
                    }
                  });

                case 3:
                  i18n.changeLanguage(id);

                  _jsCookie["default"].set('next-i18next-browser', id);

                case 5:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));
      }

    case _menu.MENU_ACTION_TYPES.CURRENCY:
      return function () {
        return setCurrency(id);
      };

    default:
      return undefined;
  }
};

exports.getAction = getAction;